import { render, staticRenderFns } from "./edit-settings-modal.vue?vue&type=template&id=10316db1&scoped=true&"
import script from "./edit-settings-modal.js?vue&type=script&lang=js&"
export * from "./edit-settings-modal.js?vue&type=script&lang=js&"
import style0 from "./edit-settings-modal.scss?vue&type=style&index=0&id=10316db1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10316db1",
  null
  
)

export default component.exports